var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-background pt-0"},[_vm._t("default"),_c('footer-minimal')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }